import { borderRadius, generateBorders, generateShadows } from './layout';
import palettes from './palettes';
import {
  padding,
  margin,
  mobilePadding,
  mobileMargin
} from './themeV2/spacing';
import { fontSize, fontWeight, fontSizeMob } from './themeV2/typography';

export default function getTheme(
  colorTheme = 'blue',
  fontFamily = 'Arial',
  isMobile
) {
  const palette = palettes[colorTheme] || palettes['blue'];
  const typography = {
    fontFamily: `"${fontFamily}", "Roboto", "Helvetica", "Arial", "sans-serif"`,
    fontSize: isMobile ? fontSizeMob : fontSize,
    fontWeight
  };
  const shape = { borderRadius };
  const spacing = {
    padding: isMobile ? mobilePadding : padding,
    margin: isMobile ? mobileMargin : margin
  };
  return {
    palette,
    shape,
    typography,
    shadows: generateShadows(palette),
    borders: generateBorders(palette)
    // spacing
  };
}
